
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-center/search",
      function () {
        return require("private-next-pages/learning-center/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-center/search"])
      });
    }
  